// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__1jB6L"};